import {MyButtonProps} from "./props";
import {StyledButton} from "./styles";
import {ConfigProvider} from "antd";
import {lighten} from "polished";

const defaultConfig = {
  controlHeight: 48,
  borderRadius: 12,
  fontSize: 16,
  paddingInline: 24,
  fontWeight: 600
}

const roundedConfig = {
  borderRadius: 40,
}

const orangeConfig = {
  colorPrimary: '#FF9500',
  colorPrimaryBorder: '#FF9500',
  colorPrimaryHover: lighten(0.1, '#FF9500'),
}

const orangeRoundedConfig = {
  colorPrimary: 'rgba(244, 245, 247, 1)',
  colorPrimaryBorder: '#FF9500',
  colorPrimaryHover: '#FF9500',
  colorText: 'rgba(104, 114, 125, 1)',
  colorTextHover: 'white',
}

const blueConfig = {
  colorPrimary: '#00BDF4',
  colorPrimaryBorder: '#00BDF4',
  colorPrimaryHover: lighten(0.1, '#00BDF4'),
}

export const MyButton = ({color, rounded, ...otherProps}: MyButtonProps) => {
  return (
    <ConfigProvider theme={{
      components: {
        Button: {
          ...defaultConfig,
          ...(
            rounded ? roundedConfig : {}
          ),
          ...(color === 'orange' && rounded ? orangeRoundedConfig : {}),
          ...(color === 'orange' && !rounded ? orangeConfig : {}),
          ...(color === 'blue' ? blueConfig : {}),
        }
      }
    }}>
      <StyledButton className={color} {...otherProps} />
    </ConfigProvider>
  )
}